import React, { useCallback } from "react";
import { useAccountContacts } from "../../api/hooks/useAccountContacts";
import { useFallbackUrl, useNavigator } from "../../components/AppHistory";
import { ModalComponent } from "../../pages/routes";

import { CallVerificationDialog } from "./components/CallVerificationDialog";
import { useParams } from "react-router-dom";

function isError(error: unknown): error is Error {
  return error instanceof Error;
}

export const CallVerificationDialogContainer: ModalComponent = ({
  fallbackUrl,
}) => {
  useFallbackUrl(fallbackUrl);
  const { accountNumber } = useParams();
  const { closeOverlay, confirmOverlay } = useNavigator();

  const onSkip = useCallback(() => {
    confirmOverlay(`/accounts/${accountNumber}`);
  }, [accountNumber, confirmOverlay]);

  const onConfirm = useCallback(() => {
    confirmOverlay(`/accounts/${accountNumber}`);
  }, [accountNumber, confirmOverlay]);

  const onCancel = useCallback(() => {
    closeOverlay();
  }, [closeOverlay]);

  const { data: contacts, error: contactsError } = useAccountContacts(
    accountNumber,
  );

  return (
    <CallVerificationDialog
      data-testid="CallVerificationDialog"
      contacts={contacts ?? null}
      accountNumber={accountNumber}
      error={isError(contactsError) ? contactsError : null}
      onSkip={onSkip}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
